import Link from 'next/link';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import type { Network } from '../helpers';

import { ScNetworkItem } from './styled';

export const NetworkItem: FC<Network> = ({ textKey, icon, link, id }) => {
  const { t } = useTranslation('common');

  return (
    <Link aria-label={id} href={link} target="_blank">
      <ScNetworkItem>
        <ImageComponent alt={id} height={80} src={icon} width={80} />
        <div className="text">{t(textKey, { network: id })}</div>
      </ScNetworkItem>
    </Link>
  );
};
